// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__QO_H5","icon":"styles_icon__Lex1w","label":"styles_label__zosOj"};